import * as React from "react";
import { Layout, Input, Button, Divider } from "antd";
import { Formik } from "formik";
import styled from "styled-components";
import { checkPermission } from "../AdminUser/CheckAdminPermission";
import { CustomModal } from "../common/CustomModal";

const { Content } = Layout;

const StyleDivider = styled(Divider)`
  &.ant-divider-horizontal {
    margin: 14px 0px;
  }
`;

export class AddLanguage extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      data: [],
      view: false,
      isLoading: false,
      visible: false,
    };
  }

  validateForm = (values) => {
    const errors = {};
    if (!values.name) {
      errors.name = "Language name is required";
    }
    return errors;
  };

  handleSubmit(values, action) {
    console.log("Basic Value - ", values);
    this.props.onSubmit(values);
    this.setState({
      visible: false,
    });
  }

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleCancel = () => {
    this.setState({
      visible: false,
    });
  };

  render() {
    const { primaryColor, loginData } = this.props;
    // Fix permission check: check language module instead of users
    const hasPermission = checkPermission(loginData, "language", "create");

    return (
      <div>
        <div
          onClick={hasPermission ? this.showModal : null}
          style={{
            width: "100px",
            backgroundColor: primaryColor,
            color: "white",
            padding: "7px 0px",
            textAlign: "center",
            borderRadius: "50px",
            cursor: hasPermission ? "pointer" : "not-allowed",
            opacity: hasPermission ? 1 : 0.5,
            pointerEvents: hasPermission ? "auto" : "none",
          }}
        >
          ADD
        </div>
        
        <CustomModal
          width="1000px"
          visible={this.state.visible}
          title="Add Language"
          onClose={this.handleCancel}
        >
          <Content style={{ background: "#fff", marginLeft: "10px" }}>
            <Formik
              initialValues={{
                name: "",
              }}
              validate={this.validateForm}
              onSubmit={this.handleSubmit}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
              }) => {
                return (
                  <div>
                    <div className="formik-field_wrap">
                      <div className="formik-field-left">
                        Name
                        <Input
                          id="name"
                          placeholder="Name"
                          value={values.name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors.name && touched.name ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {errors.name}
                          </p>
                        ) : null}
                      </div>
                    </div>

                    <Button
                      style={{
                        marginTop: "19px",
                        background: "#5C6AC4",
                        color: "#fff",
                      }}
                      onClick={handleSubmit}
                    >
                      Add
                    </Button>
                  </div>
                );
              }}
            </Formik>
          </Content>
        </CustomModal>
      </div>
    );
  }
}
